export default initialState =>
  (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case 'SET_ISSUE':
        return {
          ...state,
          issues: [...state.issues, payload.issue],
        };
      case 'REMOVE_ISSUE':
        return {
          ...state,
          issues: state.issues.filter(issue => issue.id !== payload.annotationId),
        };
      case 'SET_ISSUES':
        return {
          ...state,
          issues: [...payload.issues],
        };
      case 'UPDATE_ISSUE':
        return {
          ...state,
          issues: state.issues.map(issue => (issue.id === payload.issueId ? { ...issue, ...payload.updates } : issue)),
        };
      default:
        return state;
    }
  };
